import { getMentionNotificationCommentUtil, getReplyNotificationCommentUtil } from 'models/daos/comment/utils'
import { NOTIFICATION_MODEL_TYPE } from 'models/daos/notification/constants'
import { getNotificationOrderUtil } from 'models/daos/order/utils'
import { getNotificationCartUtil } from 'modules/cart/utils'

function getContentObjNotificationUtil (instance, associatedInstances) {
  const typeContentFnMap = {
    [NOTIFICATION_MODEL_TYPE.CART_ADD_PRODUCT]: getNotificationCartUtil,
    [NOTIFICATION_MODEL_TYPE.ORDER_STATUS_CHANGE]: getNotificationOrderUtil,
    [NOTIFICATION_MODEL_TYPE.COMMENT_REPLY]: getReplyNotificationCommentUtil,
    [NOTIFICATION_MODEL_TYPE.COMMENT_MENTION]: getMentionNotificationCommentUtil
  }
  return typeContentFnMap[instance.data.type](instance, associatedInstances)
}

export {
  getContentObjNotificationUtil
}
